import './index.scss'
import { axios as $http } from 'cm'
import api from './api'
import qs from 'qs'
import Bridge from '../../../frontend-lib/lib/Bridge'
// import GetQueryString from '../../../public-resource/get-query/index'
import monitor from 'src/frontend-lib/lib/monitor'
import { wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'
import invitationPoster from '../../../public-resource/components/invitationPoster'
;(function() {
  // let tag = GetQueryString('tag')
  let myBridge = new Bridge()

  // let page = 1
  let firstShowList = true
  let wrapHeight = 0
  let listHeight = 0
  let isLoadList = false
  let inviteTitle = '成为答主，用爱治愈世界'
  let recordTitle = '邀请记录'
  let hash = 'invite'

  let inviteWrap = $('.invite-wrap')
  let inviteMain = $('.invite-main')
  let withdrawTotal = $('.withdraw-total span')
  let withdrawReady = $('.withdraw-ready span')
  let withdrawBalance = $('.withdraw-balance span')
  let withdrawBtn = $('.record-withdraw-btn')
  let weChatToast = $('.show-wechat')

  let unionid = window.baseInfo.wx_user_details.union_id
  let openid = window.baseInfo.wx_user_details.open_id

  let $shareConfig = {
    link: window.baseInfo.wx_share.url.replace(
      window.location.protocol + getEnvHost(`//m.xinli001.com`),
      wxConfigOrigin(
        require('../../../../yxlConfig.json'),
        'QA_ORIGIN',
        'm_safe'
      )
    ),
    imgUrl: window.baseInfo.wx_share.image,
    desc: window.baseInfo.wx_share.desc,
    title: window.baseInfo.wx_share.title
  }

  function isRecordTab() {
    return (location.hash || '').replace(/^\#/, '') === 'record'
  }

  let IS_APP = window.$platform.isYixinliApp
  let IS_WECHAT = window.$platform.isWechat
  if (IS_APP) {
    $('.invite-header').remove()
    $('body').addClass('isApp')
    myBridge.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })
    window.myBridge = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback(ops) {
            if (ops.name === 'shareReportBtn') {
              myBridge.call('shareReport', $shareConfig)
            }
          }
        }
      ]
    })
  }

  if (IS_WECHAT) {
    wxShare($shareConfig)
  }

  let gobackIcon = $('.yxl-font-back')
  gobackIcon.click(function() {
    window.history.back()
  })

  $('.share').on('click', function() {
    // 客户端触发不到
    if (IS_WECHAT) {
      // 微信端
      window.toast('请点击右上角分享给好友!')
    } else {
      // h5
      let selection = window.getSelection() // Save the selection.
      let range = document.createRange()
      let $url = document.createElement('div')

      $url.display = 'none'
      // $url.innerHTML = $config.url;
      $url.innerHTML = window.location.href

      document.body.appendChild($url)

      range.selectNodeContents($url)
      selection.removeAllRanges() // Remove all ranges from the selection.
      selection.addRange(range) // Add the new range.

      document.execCommand('copy')

      selection = null
      range = null
      document.body.removeChild($url)

      window.toast('复制链接成功')
    }
  })

  let init = function() {
    // 抽一张宣言
    $('.declaration-choice').on('click', function() {
      $http
        .get(api.getDeclaration, {
          disabledUnLoginInterceptors: true
        })
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.data
            $('.card-info-ava img').attr(
              'src',
              data.avatar
                ? data.avatar
                : 'http://image.xinli001.com/images/avatar.jpg'
            )
            $('.card-info-name').text('来自' + data.nickname)
            $('.card-info-profile .date').text(data.exists_day.slice(0, -1))
            $('.card-info-profile .totals').text(data.answer_total)

            let desc = $('.card-slogan div')
            desc.html(data.content)

            $('.invitation-card-toast').css('display', '')
            $('.card-info-container').scrollLeft(0)
            desc.scrollTop(0)
          }
        })
        .catch(err => {
          console.error(err)
          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.getDeclaration,
            apiParams: JSON.stringify({
              disabledUnLoginInterceptors: true
            })
          })
        })
    })
    $('.card-close').on('click', function() {
      $('.invitation-card-toast').css('display', 'none')
    })

    // 选项卡切换
    $('.invite-footer').on('click', function(ev) {
      let currentTag = ev.target.className
      if (currentTag === 'tab-' + hash) {
        return
      }
      if (currentTag === 'tab-invite') {
        $('.invite-main-left').css('display', '')
        $('.invite-main-right').css('display', 'none')
        hash = 'invite'

        // inviteWrap.scrollTop(inviteMain.height() - $(document).height())
      } else {
        $('.invite-main-left').css('display', 'none')
        $('.invite-main-right').css('display', '')
        hash = 'record'
        if (firstShowList && IS_WECHAT) {
          getRecordList()
        }
        if (!IS_WECHAT) {
          showWechatToast()
        }
      }
      setTitle(hash)
    })
    if (isRecordTab()) {
      $('.invite-footer').trigger('click')
    } else {
      setTitle(hash)
    }

    // 关闭微信弹窗
    weChatToast.on('click', function() {
      $(this).css('display', 'none')
    })

    // 初始化邀新海报
    const InvitationPoster = new invitationPoster()
    $('.selfHeadling-btn').on('click', function() {
      InvitationPoster.show(window.baseInfo.qrCodeImage)
    })

    // 提现
    withdrawBtn.on('click', function() {
      let coin = withdrawBalance.text()
      if (+coin === 0) {
        return
      }
      withdrawBtn.css('background', '#bcc2cf')
      $http
        .post(
          api.withdraw,
          qs.stringify({
            unionid,
            openid
          })
        )
        .then(res => {
          if (res.data.errcode === 0) {
            window.toast('提现成功')
            modifyWithdrawInfo(res.data.data.info)
          } else {
            window.toast('提现失败 ' + res.data.errcode)
            withdrawBtn.css('background', '#ff745b')
          }
        })
        .catch(err => {
          withdrawBtn.css('background', '#ff745b')
          console.error(err)
          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.withdraw,
            apiParams: JSON.stringify({
              unionid,
              openid
            })
          })
        })
    })
  }

  init()

  // $('.record-table-list').on('scroll', function(ev) {
  //   if (!wrapHeight) {
  //     wrapHeight = $('.record-table-list').height()
  //   }
  //   if (wrapHeight + $(this).scrollTop() > listHeight - 1) {
  //     getRecordList()
  //   }
  // })

  function getRecordList() {
    if (isLoadList) {
      return
    }
    isLoadList = true
    firstShowList = false
    let params = {
      // eventid: 44
      eventid: 19
    }
    $http
      .get(api.getRecordList + '?unionid=' + unionid, {
        params
      })
      .then(res => {
        if (res.data.errcode === 0) {
          modifyWithdrawInfo(res.data.data.info)
          let list = res.data.data.infolist
          if (list && list.length) {
            let dataTemplate = ''
            list.forEach(item => {
              if (+item.flag !== 9) {
                let type = judgeType(item)
                dataTemplate += `<li>
                  <span>${item.title}</span>
                  <span>${type.execution}</span>
                  <span style="color: ${type.color}">${type.record}</span>
                </li>`
              }
            })
            // page++
            $('.record-table-list ul').append(dataTemplate)
            isLoadList = false

            // listHeight = $('.record-table-list ul').height()
            // if (listHeight < wrapHeight - 1) {
            //   getRecordList()
            // }
          } else {
            // noDataTemplate
            // $('.record-table-list').off('scroll')
            window.toast('暂无邀请记录，快去邀请好友吧！')
          }
        } else {
          // $('.record-table-list').off('scroll')
          window.toast('数据异常 ' + res.data.errcode)
        }
      })
      .catch(err => {
        // $('.record-table-list').off('scroll')
        console.error(err)
        monitor.stat({
          level: 'error',
          error: 'api-data',
          msg: err,
          api: api.getRecordList + '?unionid=' + unionid,
          apiParams: JSON.stringify({
            params
          })
        })
      })
  }

  function judgeType(item) {
    let type = {}
    let flag = item.flag
    switch (flag) {
      case 0:
        type.execution = '已扫码'
        type.color = '#BCC2CF'
        type.record = '未完成'
        break
      case 1:
        type.execution = '星标回答'
        type.color = '#FF745B'
        type.record = `${unitConversion(item.amount)}元`
        break
      case 2:
        type.execution = '1星答主'
        type.color = '#FF745B'
        type.record = `${unitConversion(item.amount)}元`
        break
      case 3:
        type.execution = '额外奖励'
        type.color = '#FF745B'
        type.record = `${unitConversion(item.amount)}元`
        break
      case 8:
        type.execution = '已扫码'
        type.color = '#14CC76'
        type.record = '任务超时'
        break
      default:
        type.execution = ''
        type.color = ''
        type.record = ''
    }
    return type
  }

  function unitConversion(value) {
    return value / 100
  }

  function modifyWithdrawInfo(info) {
    let withdraw_ready = unitConversion(info.tixian)
    let withdraw_balance = unitConversion(info.amount)
    let withdraw_total = withdraw_ready + withdraw_balance
    withdrawTotal.text(withdraw_total)
    withdrawReady.text(withdraw_ready)
    withdrawBalance.text(withdraw_balance)
    if (withdraw_balance) {
      withdrawBtn.css('background', '#ff745b')
    }
  }

  function showWechatToast() {
    weChatToast.css('display', '')
  }
  function setTitle(hash) {
    let title
    if (hash === 'invite') {
      title = inviteTitle
    } else {
      title = recordTitle
    }
    if (!IS_APP) {
      $('.invite-header .title').text(title)
    } else {
      myBridge.call('setTitle', {
        title
      })
    }
    document.title = title
    // location.hash = hash
  }

  function wxShare(config) {
    let currentUrl = document.location.href.split('#')[0]
    let getWxConfig = api.getWXShareConfig
    let title = config.title
    let imgUrl = config.imgUrl
    let desc = config.desc
    let link = config.link
    $http
      .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
      .then(res => {
        if (res.data.code == 0) {
          var wxConfig = res.data.data

          function loadScript(url, callback) {
            var script = document.createElement('script')
            script.type = 'text/javascript'
            if (typeof callback !== 'undefined') {
              if (script.readyState) {
                script.onreadystatechange = function() {
                  if (
                    script.readyState == 'loaded' ||
                    script.readyState == 'complete'
                  ) {
                    script.onreadystatechange = null
                    callback()
                  }
                }
              } else {
                script.onload = function() {
                  callback()
                }
              }
            }
            script.src = url
            document.body.appendChild(script)
          }
          setTimeout(() => {
            loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
              var _config = {
                debug: wxConfig.debug,
                appId: wxConfig.appId,
                timestamp: wxConfig.timestamp,
                nonceStr: wxConfig.nonceStr,
                signature: wxConfig.signature,
                jsApiList: [
                  'onMenuShareTimeline',
                  'onMenuShareAppMessage',
                  'onMenuShareQQ',
                  'onMenuShareWeibo',
                  'onMenuShareQZone',
                  'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                  'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              }
              // 微信基本配置信息
              wx.config(_config)
              wx.error(function(res) {
                console.log(res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              })
              wx.ready(function() {
                var shareConfig = {
                  title,
                  desc,
                  link,
                  imgUrl,
                  success: function(res) {},
                  cancel: function(res) {},
                  fail: function(res) {}
                }
                // 分享到朋友圈
                wx.onMenuShareTimeline(shareConfig)
                // 分享给朋友
                wx.onMenuShareAppMessage(shareConfig)
                // 分享到QQ
                wx.onMenuShareQQ(shareConfig)
                // 分享到腾讯微博
                wx.onMenuShareWeibo(shareConfig)
                // 分享到QQ空间
                wx.onMenuShareQZone(shareConfig)
                wx.updateAppMessageShareData(shareConfig)
                wx.updateTimelineShareData(shareConfig)
              })
            })
          }, 500)
        }
      })
  }
})(window)



// WEBPACK FOOTER //
// ./src/pages/ask/inviteAnswer/index.js